function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDebounce } from 'react-use';
import { transparentize } from 'polished';
import { colors } from '@keen.io/colors';
import { Input, DropableContainer, DropdownListContainer, Dropdown, DropdownList, Checkbox, KEYBOARD_KEYS, Alert } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
import { useKeypress } from '@keen.io/react-hooks';
import { Container, Row, MultiControl, ControlContainer, StyledLabel, LabelText } from './NumericFormatter.styles';
import { DEFAULT_FORMATTER_PATTERN } from '../../../../../constants';
import { createFormatterSettings } from '../../../../../utils';
import { serializeFormatterSettings } from '../../../../../serializers';
import { PrefixAndSuffix } from '../components';
import { PATTERNS_OPTIONS as patterns, OPERATIONS_OPTIONS as operationsOptions } from './constants';
var initialState = {
  prefix: '',
  suffix: '',
  precision: '',
  operation: null,
  value: '',
  separator: false
};

var NumericFormatter = function NumericFormatter(_ref) {
  var formatValue = _ref.formatValue,
      onUpdateFormatValue = _ref.onUpdateFormatValue;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      dropdown = _useState2[0],
      setDropdown = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectionIndex = _useState4[0],
      setIndex = _useState4[1];

  var _useState5 = useState(initialState),
      _useState6 = _slicedToArray(_useState5, 2),
      formatterElements = _useState6[0],
      setFormatterElements = _useState6[1];

  var _useState7 = useState(formatValue),
      _useState8 = _slicedToArray(_useState7, 2),
      format = _useState8[0],
      setFormat = _useState8[1];

  var _useState9 = useState({
    hasError: false,
    message: ''
  }),
      _useState10 = _slicedToArray(_useState9, 2),
      error = _useState10[0],
      setError = _useState10[1];

  var hasError = error.hasError,
      errorMessage = error.message;
  useEffect(function () {
    var settings = createFormatterSettings(formatValue, 'number');
    setFormatterElements(function (formatterElements) {
      return _objectSpread(_objectSpread({}, formatterElements), settings);
    });
  }, [formatValue]);
  var precision = formatterElements.precision,
      operation = formatterElements.operation,
      value = formatterElements.value,
      separator = formatterElements.separator;
  useDebounce(function () {
    return onUpdateFormatValue(format);
  }, 300, [format]);

  var updateFormat = function updateFormat(values) {
    var updatedState = _objectSpread(_objectSpread({}, formatterElements), values);

    setFormatterElements(updatedState);
    setFormat(serializeFormatterSettings(updatedState));
  };

  var patternsOptions = useMemo(function () {
    return [{
      label: t(DEFAULT_FORMATTER_PATTERN.label),
      value: DEFAULT_FORMATTER_PATTERN.value
    }].concat(_toConsumableArray(patterns));
  }, [patterns]);
  var patternOption = patternsOptions.find(function (p) {
    return p.value === precision;
  }) || patternsOptions[0];
  var operationOption = operationsOptions.find(function (o) {
    return o.value === operation;
  });
  var isPrecisionOpen = dropdown === 'precision';
  var isOperationOpen = dropdown === 'operation';
  var precisionSpecified = precision && precision !== DEFAULT_FORMATTER_PATTERN.value;

  var onPrecisionChange = function onPrecisionChange(_e, _ref2) {
    var precisionValue = _ref2.value;

    if (patternOption.value === DEFAULT_FORMATTER_PATTERN.value) {
      updateFormat({
        separator: true
      });
    }

    if (precisionValue === DEFAULT_FORMATTER_PATTERN.value) {
      updateFormat({
        separator: false
      });
    }

    updateFormat({
      precision: precisionValue
    });
  };

  useEffect(function () {
    var precision = formatterElements.precision,
        operation = formatterElements.operation;
    var index = 0;

    if (isPrecisionOpen) {
      var precisionIndex = patternsOptions.findIndex(function (_ref3) {
        var value = _ref3.value;
        return value === precision;
      });
      if (precisionIndex > 0) index = precisionIndex;
    }

    if (isOperationOpen) {
      var operationIndex = operationsOptions.findIndex(function (_ref4) {
        var value = _ref4.value;
        return value === operation;
      });
      if (operationIndex > 0) index = operationIndex;
    }

    setIndex(index);
    return function () {
      setIndex(null);
    };
  }, [isPrecisionOpen, isOperationOpen]);
  var keyboardHandler = useCallback(function (_e, keyCode) {
    switch (keyCode) {
      case KEYBOARD_KEYS.ENTER:
        if (isPrecisionOpen) {
          var _value = patternsOptions[selectionIndex].value;
          onPrecisionChange(_e, {
            value: _value
          });
        }

        if (isOperationOpen) {
          var _value2 = operationsOptions[selectionIndex].value;
          updateFormat({
            operation: _value2
          });
        }

        setDropdown(null);
        break;

      case KEYBOARD_KEYS.UP:
        if (selectionIndex > 0) {
          setIndex(selectionIndex - 1);
        }

        break;

      case KEYBOARD_KEYS.DOWN:
        if (selectionIndex === null) {
          setIndex(0);
        } else if (isPrecisionOpen && selectionIndex < patternsOptions.length - 1 || isOperationOpen && selectionIndex < operationsOptions.length - 1) {
          setIndex(selectionIndex + 1);
        }

        break;

      case KEYBOARD_KEYS.ESCAPE:
        setDropdown(null);
        break;
    }
  }, [selectionIndex, isPrecisionOpen, isOperationOpen]);
  useKeypress({
    keyboardAction: keyboardHandler,
    handledKeys: [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.ESCAPE, KEYBOARD_KEYS.UP, KEYBOARD_KEYS.DOWN],
    addEventListenerCondition: isOperationOpen || isPrecisionOpen,
    eventListenerDependencies: [dropdown, selectionIndex, patternsOptions, operationsOptions]
  });
  return React.createElement(Container, null, React.createElement(PrefixAndSuffix, {
    onChange: function onChange(values) {
      return updateFormat(_objectSpread({}, values));
    },
    prefix: formatterElements.prefix,
    suffix: formatterElements.suffix
  }), React.createElement(Row, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.precision')), React.createElement(ControlContainer, null, React.createElement(DropableContainer, {
    variant: "secondary",
    placeholder: t('widget_customization_format_value_settings.select_pattern_placeholder'),
    onClick: function onClick() {
      return dropdown === 'precision' ? setDropdown(null) : setDropdown('precision');
    },
    isActive: isPrecisionOpen,
    value: patternOption.value,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDropdown(null);
    }
  }, patternOption.value === DEFAULT_FORMATTER_PATTERN.value ? React.createElement(BodyText, {
    variant: "body2",
    color: transparentize(0.5, colors.black[100])
  }, patternOption.label) : patternOption.label), React.createElement(Dropdown, {
    isOpen: isPrecisionOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: patternsOptions,
      setActiveItem: function setActiveItem(_ref5) {
        var value = _ref5.value;
        return patternsOptions[selectionIndex] && patternsOptions[selectionIndex].value === value;
      },
      onClick: onPrecisionChange
    });
  })))), React.createElement("div", null, React.createElement(Row, {
    isDisabled: !precisionSpecified
  }, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.calculate')), React.createElement(MultiControl, {
    isDisabled: !precisionSpecified
  }, React.createElement(ControlContainer, null, React.createElement(DropableContainer, {
    variant: "secondary",
    placeholder: t('widget_customization_format_value_settings.select_operations_placeholder'),
    onClick: function onClick() {
      return dropdown === 'operation' ? setDropdown(null) : setDropdown('operation');
    },
    isActive: isOperationOpen,
    value: operationOption === null || operationOption === void 0 ? void 0 : operationOption.value,
    dropIndicator: true,
    onDefocus: function onDefocus() {
      return setDropdown(null);
    },
    borderRadius: "4px 0 0 4px"
  }, operationOption === null || operationOption === void 0 ? void 0 : operationOption.label), React.createElement(Dropdown, {
    isOpen: isOperationOpen
  }, React.createElement(DropdownListContainer, {
    scrollToActive: true,
    maxHeight: 150
  }, function (activeItemRef) {
    return React.createElement(DropdownList, {
      ref: activeItemRef,
      items: operationsOptions,
      setActiveItem: function setActiveItem(_ref6) {
        var value = _ref6.value;
        return operationsOptions[selectionIndex] && operationsOptions[selectionIndex].value === value;
      },
      onClick: function onClick(_e, _ref7) {
        var operationValue = _ref7.value;
        updateFormat({
          operation: operationValue
        });
      }
    });
  }))), React.createElement(Input, {
    "data-testid": "input-value",
    value: value || '',
    variant: "solid",
    hasError: hasError,
    placeholder: t('widget_customization_format_value_settings.value_placeholder'),
    borderRadius: "0 4px 4px 0",
    type: "text",
    onChange: function onChange(e) {
      var inputValue = e.currentTarget.value;

      if (inputValue.includes(',')) {
        setError({
          hasError: true,
          message: 'widget_customization_format_value_settings.use_dot_instead_of_comma'
        });
      }

      if (!isNaN(inputValue)) {
        updateFormat({
          operation: inputValue === '' ? null : formatterElements.operation,
          value: inputValue
        });
        setError({
          hasError: false,
          message: ''
        });
      }
    },
    onBlur: function onBlur() {
      return setError({
        hasError: false,
        message: ''
      });
    }
  }))), hasError && React.createElement(Row, {
    marginTop: 10
  }, React.createElement(Alert, {
    type: "error",
    contentWidth: true
  }, t(errorMessage))), React.createElement(Row, {
    marginTop: "10px",
    marginBottom: "5px",
    isDisabled: !precisionSpecified
  }, React.createElement(StyledLabel, {
    htmlFor: "separator",
    "data-testid": "separator"
  }, React.createElement(Checkbox, {
    id: "separator",
    disabled: !precisionSpecified,
    onChange: function onChange() {
      return updateFormat({
        separator: !separator
      });
    },
    checked: !!separator
  }), React.createElement(LabelText, null, React.createElement(BodyText, {
    variant: "body2",
    fontWeight: "bold"
  }, t('widget_customization_format_value_settings.separator')))))));
};

export default NumericFormatter;